var _path, _g, _path2, _path3, _path4, _rect, _rect2, _path5, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserReferenceEmptyDarkImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13225_8089",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 184V0H183.942V184H0Z",
    fill: "#76ABC4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13225_8089)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.945 91.9423C183.945 142.784 142.729 184 91.8876 184C41.046 184 -0.169922 142.784 -0.169922 91.9423C-0.169922 41.1007 41.046 -0.115234 91.8876 -0.115234C142.729 -0.115234 183.945 41.1007 183.945 91.9423Z",
    fill: "url(#paint0_linear_13225_8089)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.194 142.362H62.8444C60.3094 142.362 57.8782 141.355 56.0857 139.562C54.2932 137.77 53.2861 135.338 53.2861 132.803V56.3372V128.024C53.2861 130.559 54.2932 132.991 56.0857 134.783C57.8782 136.576 60.3094 137.583 62.8444 137.583H120.194C122.729 137.583 125.16 136.576 126.953 134.783C128.745 132.991 129.752 130.559 129.752 128.024V132.803C129.752 135.338 128.745 137.77 126.953 139.562C125.16 141.355 122.729 142.362 120.194 142.362Z",
    fill: "#1B2B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.752 128.025C128.752 130.294 127.851 132.471 126.246 134.076C124.641 135.681 122.464 136.583 120.194 136.583H62.8444C60.5746 136.583 58.3978 135.681 56.7928 134.076C55.1878 132.471 54.2861 130.294 54.2861 128.025V51.5583C54.2861 49.2885 55.1878 47.1117 56.7928 45.5067C58.3978 43.9017 60.5746 43 62.8444 43H120.194C122.464 43 124.641 43.9017 126.246 45.5067C127.851 47.1117 128.752 49.2885 128.752 51.5583V128.025Z",
    fill: "#09172A",
    stroke: "#09172A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.248 42.493V60.8945C103.248 61.5136 103.587 62.0742 104.102 62.311L104.633 62.4283C104.999 62.4285 105.35 62.2668 105.611 61.978L111.554 55.3947L117.498 61.978C117.759 62.2668 118.11 62.4285 118.476 62.4283L119.005 62.311C119.256 62.1977 119.472 62.0024 119.624 61.7501C119.777 61.4978 119.859 61.1999 119.861 60.8945V42.493H103.248Z",
    fill: "#FFC97A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.7158,
    y: 93.1619,
    width: 58.1445,
    height: 2.49191,
    rx: 1.24595,
    fill: "#1B2B3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.207,
    y: 104.791,
    width: 47.3462,
    height: 1.66127,
    rx: 0.830636,
    fill: "#1B2B3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5303 77.3797C68.1874 77.3797 68.8298 77.1848 69.3762 76.8198C69.9226 76.4547 70.3484 75.9358 70.5999 75.3286C70.8514 74.7215 70.9172 74.0535 70.789 73.409C70.6608 72.7645 70.3443 72.1724 69.8797 71.7078C69.415 71.2431 68.823 70.9267 68.1785 70.7985C67.534 70.6703 66.8659 70.7361 66.2588 70.9875C65.6517 71.239 65.1328 71.6649 64.7677 72.2113C64.4026 72.7576 64.2077 73.4 64.2077 74.0572C64.2077 74.9384 64.5578 75.7835 65.1809 76.4066C65.804 77.0297 66.6491 77.3797 67.5303 77.3797ZM72.5141 85.6861C72.7344 85.6861 72.9457 85.5986 73.1014 85.4428C73.2572 85.287 73.3447 85.0757 73.3447 84.8554C73.3447 83.3133 72.7321 81.8344 71.6417 80.744C70.5513 79.6536 69.0724 79.041 67.5303 79.041C65.9882 79.041 64.5093 79.6536 63.4188 80.744C62.3284 81.8344 61.7158 83.3133 61.7158 84.8554C61.7158 85.0757 61.8033 85.287 61.9591 85.4428C62.1149 85.5986 62.3262 85.6861 62.5465 85.6861H72.5141Z",
    fill: "#223446"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5449,
    y: 98.9763,
    width: 20.7659,
    height: 1.66127,
    rx: 0.830636,
    fill: "#223446"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0371,
    y: 109.775,
    width: 21.5965,
    height: 1.66127,
    rx: 0.830636,
    fill: "#223446"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13225_8089",
    x1: 3.51238,
    y1: 3.75118,
    x2: 131.841,
    y2: 119.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525050",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReferenceEmptyDarkImg);
export default __webpack_public_path__ + "static/media/user-reference-empty-dark-img.8f85894be63e0e2385a67b297d22e989.svg";
export { ForwardRef as ReactComponent };